import React, { Component } from 'react';
import { string } from '../../localization';
import { Icons } from '../../utilities';
import Preview from '../VanillaDesign/VanillaFinalCheck/Preview';
import '../VanillaDesign/VanillaFinalCheck/VanillaFinalCheck.scss';
import './Processing.scss';
import { connect } from 'react-redux';
import * as fabricCanvasActions from '../../redux/fabricCanvasActions';
import FeedbackDialogue from '../FeedbackDialogue/FeedbackDialogue';
import * as CookieUtils from '../../utilities/CookieUtils/CookieUtils';
import { bindActionCreators } from 'redux';
import { getPrinitingOptionKey } from '../../utilities/CookieUtils/CookieUtils';
import * as Constants from '../../utilities/constants/Constants';

class Processing extends Component {
  state = {
    isHpSelected: false
  };

  componentDidMount() {
    const { feedbackDuration, feedbackState, isFeedbackVisible } = this.props;
    this.isHpSelected();
    const shouldShowFeedback = CookieUtils.resumeFeedbackCookie(
      feedbackDuration
    );
    if (
      (shouldShowFeedback === undefined || !shouldShowFeedback) &&
      feedbackState &&
      isFeedbackVisible
    ) {
      this.startTimer();
    }
  }

  componentWillUnmount() {
    const { feedbackDuration, feedbackState, isFeedbackVisible } = this.props;
    const shouldShowFeedback = CookieUtils.resumeFeedbackCookie(
      feedbackDuration
    );

    if (
      (shouldShowFeedback === undefined || !shouldShowFeedback) &&
      feedbackState &&
      isFeedbackVisible
    ) {
      this.stopTimer();
    }
  }

  isHpSelected = () => {
    const { storeDataId } = this.props;
    const selctedPrintingOption = getPrinitingOptionKey(storeDataId);
    if (selctedPrintingOption === 0) {
      this.setState({
        isHpSelected: true
      });
    } else {
      this.setState({
        isHpSelected: false
      });
    }
  };

  tick = () => {
    const { dispatchers } = this.props;
    dispatchers.fabricCanvasActions.setFeedbackDialogue(true);
  };

  startTimer = () => {
    this.interval = setInterval(
      this.tick,
      Constants.FEEDBACK_INTERVAL_FOR_PROCESSING_PAGE
    );
  };

  stopTimer = () => {
    clearInterval(this.interval);
  };

  render() {
    const { orientation, showFeedbackDialogue } = this.props;
    const { isHpSelected } = this.state;
    return (
      <div
        className={`vanilla-final-check d-flex ${
          orientation == 'Landscape' ? 'landscape-style' : 'potrait-style'
        }`}
      >
        <Preview />
        <div id='overlay' />
        <div className='processingBlock'>
          <div>
            <h2 className='heading'>{string.PROCESSING_DONE}</h2>
          </div>
          <div className='row processingInnerBlock'>
            <div>
              <h4 className='processingDone'>{string.PROCESSING_FILE_TXT}</h4>
            </div>
            <div>
              <span className='subHeader'>{string.PROCESSING_TIME_TXT}</span>

              {/* <span className="subHeader">{string.PROCESSING_TIME_TXT1}</span>
              <br />
              <span className="subHeader">{string.PROCESSING_TIME_TXT2}</span> */}
            </div>
            <div className='processingImg'>
              <img src={Icons.processing_icon} alt='processing-icon' />
            </div>
            <hr className='horizontalLIne' />
          </div>
          <div className='bottomBlock'>
            <img
              className='alertIcon'
              src={Icons.warning_icon}
              alt='warning-icon'
            />
            <span className='alertTxt'>{string.PROCESSING_ALERT_TXT}</span>
          </div>
          <div className='bottomBlockTxt'>
            {isHpSelected ? (
              <span className='bottomTxt'>{string.PROCESSING_ALERT_TXT2}</span>
            ) : (
              <div>
                <span className='bottomTxtNotHp'>
                  {string.PROCESSING_ALERT_TXT3}
                </span>{' '}
                <br />
                <span className='bottomTxtNotHpAdditional'>
                  {string.PROCESSING_ALERT_TXT4}
                </span>
              </div>
            )}
          </div>
        </div>
        {showFeedbackDialogue ? (
          <FeedbackDialogue onDisplay={this.stopTimer} />
        ) : null}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    storeDataId: state.modal.storeData.id,
    orientation: state.home.orientation,
    feedbackDuration: state.modal.envData.feedback_duration,
    isFeedbackVisible: state.modal.storeData.showFeedback,
    showFeedbackDialogue: state.fabricCanvas.showFeedbackDialogue,
    feedbackState: state.fabricCanvas.feedbackState
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchers: {
      fabricCanvasActions: bindActionCreators(fabricCanvasActions, dispatch)
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Processing);
